// extracted by mini-css-extract-plugin
export default {"wrap":"AnchorRef_wrap__eHsHD"};